export default __webpack_public_path__ + "static/media/Spin general_Interactive LightMix0065.401c4e8e.webp";